export function lazyInit(selector: string, load: () => Promise<void>): void {
  if (!document.querySelector(selector))
    return;

  void load().catch((error: unknown) => {
    console.error('[lazy-init] failed', selector, error);
  });
}
